import React, { useEffect, useState } from 'react';
import BaseForm from 'containers/Base/BaseForm.js';
import isEmpty from 'lodash/isEmpty';
import PropTypes from 'prop-types';
import { connect, shallowEqual, useDispatch, useSelector } from 'react-redux';
import {
  pendingCompanyActions,
  pendingCompanyPageActions,
  pendingCompanySelectors,
} from '../';
import API from 'services/api';
import { showSnackbar } from 'reducers/ui';
import { errorHandler } from 'utils/errorMessages';
import {
  createGeneralSection,
  detailSection,
  generalSection,
  initialValues,
  pendingCompanyValidationSchema,
} from './pendingCompanyFormHelper';

const PendingCompanyForm = ({
  id,
  closeForm,
  approvePendingCompany,
  editMode,
}) => {
  const [plans, setPlans] = useState();
  const [region, setRegion] = useState();

  const pendingCompany = useSelector(
    state => pendingCompanySelectors.getPendingCompanyDetails(state),
    shallowEqual,
  );
  const countries = useSelector(state => state.utils.countries, shallowEqual);
  const dispatch = useDispatch();
  const onCreate = values => {
    const pendingCompany = {
      address: values.address,
      name: values.name,
      country: values.country,
      manager: {
        email: values.email,
        firstName: values.firstName,
        lastName: values.lastName,
        phoneNumber: {
          country: values.phoneCountry,
          number: values.phoneNumber,
        },
      },
      operationsPhoneNumber: {
        country: values.operationsCountry,
        number: values.operationsPhoneNumber,
      },
    };
    dispatch(pendingCompanyActions.createRowEntry({ pendingCompany }));
  };
  const onEdit = values => {
    //get the plans into a list from the values
    const selectedPlans = [];
    //users
    if (values?.users) {
      const u = values.users;
      selectedPlans.push(
        plans.find(item => {
          return item.name === u.id;
        }),
      );
    }
    //services
    if (values?.services) {
      selectedPlans.push(
        ...appendPlans({
          selected: values.services,
          result: selectedPlans,
        }),
      );
    }
    // sites
    if (values?.sites) {
      const s = values.sites;
      selectedPlans.push(
        plans.find(item => {
          return item.name === s.id;
        }),
      );
    }
    //features
    if (values?.features) {
      selectedPlans.push(
        ...appendPlans({
          selected: values.features,
          result: selectedPlans,
        }),
      );
    }
    //languages
    if (values?.languages) {
      selectedPlans.push(
        ...appendPlans({
          selected: values.languages,
          result: selectedPlans,
        }),
      );
    }
    // others
    if (values?.others) {
      selectedPlans.push(
        ...appendPlans({
          selected: values.others,
          result: selectedPlans,
        }),
      );
    }
    //map to array of id
    if (selectedPlans.length > 0 && values?.region) {
      const subscriptions = selectedPlans.map(i => i.id);
      const regionId = values.region.id;
      approvePendingCompany({
        id: id,
        region: regionId,
        subscriptions: subscriptions,
        trialLength: values?.trialLength ? values.trialLength : 14,
        trialAutoExtendLength: values?.trialAutoExtendLength
          ? values.trialAutoExtendLength
          : 14,
      });
    }
  };
  const appendPlans = ({ selected }) => {
    const result = [];
    for (let i = 0; i < selected.length; i += 1) {
      const s = selected[i];
      result.push(
        plans.find(item => {
          return item.name === s;
        }),
      );
    }

    return result;
  };
  const onChange = vals => {
    if (!isEmpty(vals.region)) {
      setRegion(vals.region);
    }
  };
  useEffect(() => {
    const fetchRegionPlans = async region => {
      if (!isEmpty(region)) {
        try {
          const { data: plansData } = await API.fetchAllAvailablePlans(
            region.name,
          );
          // fire a notification if a company is approved
          setPlans(
            plansData.data.map(item => ({
              id: item.planId,
              name: item.displayName,
              planName: item.name,
              platform: item.platform,
              productLine: item.productLine,
            })),
          );
        } catch (err) {
          showSnackbar({
            typeOfSnackbar: 'success',
            message: errorHandler(err),
          });
        }
      }
    };

    fetchRegionPlans(region);
  }, [region]);

  return (
    <BaseForm
      allowToArchive={false}
      imageRequired={false}
      onSubmit={editMode ? onEdit : onCreate}
      onChange={onChange}
      formTitle={
        editMode ? 'Approve Pending Company' : 'Create Pending Company'
      }
      closeForm={closeForm}
      initialValues={initialValues(pendingCompany)}
      edit={true} //always editable and only in edit mode
      generalSection={
        editMode ? generalSection() : createGeneralSection(countries)
      }
      detailedSection={
        editMode ? region && plans && detailSection(plans) : null
      }
      validationSchema={pendingCompanyValidationSchema(editMode)}
    />
  );
};
PendingCompanyForm.propTypes = {
  closeForm: PropTypes.func,
  id: PropTypes.string,
  approvePendingCompany: PropTypes.func,
  editMode: PropTypes.bool,
};
const mapDispatchToProps = dispatch => ({
  approvePendingCompany: payload =>
    dispatch(pendingCompanyPageActions.acceptPendingCompany(payload)),
});

export default connect(null, mapDispatchToProps)(PendingCompanyForm);
